<template>
  <shop-default-layout is-aw-spring :spring-desktop-size="springDesktopSize">
    <template v-if="screenRange['mobile-max']" #search />
    <template #content="{ defaultLayoutClasses }">
      <div
        v-if="isEcomUser"
        :class="[defaultLayoutClasses.container, $style.profilePageContainer]"
      >
        <aw-spring :desktop-size="springDesktopSize === 100 ? 10: 100">
          <aw-tab-version2 tab-type="page" :header-items="menuItems">
            <template #content>
              <aw-tab-content-version2
                v-for="menu in menuItems"
                :key="menu.to"
                :tab-index="menu.tabItemId"
                :route-path="menu.to"
                :alternative-route-paths="menu.alternativeRoutePaths"
              />
            </template>
          </aw-tab-version2>
        </aw-spring>
      </div>
      <div v-else :class="$style.profilePageContainer" />
      <div :class="[{[$style.loggedOut]: !isEcomUser}]">
        <slot name="content">
          <slot v-if="isEcomUser" />
          <aw-profile-empty v-else />
        </slot>
      </div>
    </template>
  </shop-default-layout>
</template>

<script>
  import { mapState } from 'pinia';
  import { defineAsyncComponent } from 'vue';
  import ShopDefaultLayout from '~~/shop/app/layouts/default.vue';
  import { URL_PREFIX_WITHOUT_SLASH } from '~~/common/config/UrlConfig';
  import authMixin from '~~/common/mixins/authMixin';
  import AwTabContentVersion2 from '~~/common/components/Common/AwTabContentVersion2.vue';
  import AwProfileEmpty from '~~/common/components/Common/AwProfileEmpty.vue';

  import { useUserInterfaceStore } from '~~/common/stores/userInterface';
  import { useUserStore } from '~~/common/stores/user';
  import AwSpring from '~~/common/components/AwSpring.vue';

  export default {
    name: 'ProfileLayout',
    components: {
      AwSpring,
      AwTabContentVersion2,
      AwTabVersion2: defineAsyncComponent(() => import('~~/common/components/Common/AwTabVersion2')),
      ShopDefaultLayout,
      AwProfileEmpty,
    },
    mixins: [
      authMixin,
    ],
    props: {
      springDesktopSize: {
        type: Number,
        default: 10,
      },
    },
    computed: {
      ...mapState(useUserStore, {
        isEcomUser: state => state.isEcomUser,
      }),
      ...mapState(useUserInterfaceStore, {
        screenRange: state => state.mediaQueries,
      }),
      menuItems () {
        const profileRoutePaths = [
          'shop-profile-data',
          'shop-profile-cards',
          'shop-profile-delivery-addresses',
          'shop-profile-billing-addresses',
          'shop-profile-manage',
          'shop-profile-mailing-addresses',
        ].map(route => this.$localePath(route));

        const loyaltyProgramRoutePaths = [
          'shop-profile-loyalty-card-stickers',
          'shop-profile-loyalty-card-coupons',
          'shop-profile-loyalty-card-partner-program',
          'shop-profile-loyalty-card-transaction',
          'shop-profile-loyalty-program',
          'shop-profile-loyalty-card',
        ].map(route => this.$localePath(route));
        return [
          {
            label: this.$awt('aw.profile.menu.loyalty_program'),
            to: 'profile-loyalty-program',
            alternativeRoutePaths: loyaltyProgramRoutePaths,
            tabItemId: 'loyaltyProgram',
          },
          {
            label: this.$awt('aw.profile.menu.orders'),
            to: 'profile-orders',
            tabItemId: 'orders',
          },
          {
            label: this.$awt('aw.profile.menu.saved_baskets'),
            to: 'profile-saved-baskets',
            tabItemId: 'savedBaskets',
          },
          {
            label: this.$awt('aw.profile.menu.profile'),
            to: 'profile-data',
            alternativeRoutePaths: profileRoutePaths,
            tabItemId: 'profile',
          },
        ]
          .filter(item => item)
          .map(p => ({
            ...p,
            to: this.$localePath(URL_PREFIX_WITHOUT_SLASH + '-' + p.to),
          }))
        ;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.content {
  margin-bottom: 40px;

  @include tablet(min) {
    margin-bottom: 80px;
  }
}

.loggedOut {
  padding-top: 50px;
  @include tablet(min) {
    padding-top: 90px;
  }
}

.profilePageContainer {
  margin-top: 0;
  padding-bottom: 20px;

  @include tablet(min) {
    padding-bottom: 40px;
  }

  @include mobile(max) {
    padding-top: 70px !important;
  }
}
</style>
